export const apiUrl = {
  production: false,
  BASE_URL: 'https://wtoblw1y5e.execute-api.us-east-1.amazonaws.com/prod',
  BASE_PAY_URL: 'https://web-dev.flexipay.com.co',
  FLEXI_HOST: 'http://localhost:4200/',
  MAXGP_SYSTEM: 'https://php82.maxgp.com.co/webservice/api/V1/system',
  MAXGP_HOST_DIRECT: 'https://php82.maxgp.com.co',
  TRANS_HOST_DIRECT: 'https://tran-dev.flexipay.com.co',
  EMPRESA: 'infodec',
};

export const LoginConstants = {
  production: false,
  tax: 0,
  achCode: '209309',
  apiKey: 'e92cacd8-0a31-44f7-a0eb-75834ab53d57',
  user: 'prueba4desarrollo',
  userCommerce: 'COMERCIO4PRUEBA1',
  password: 'Camilinho.95',
  passwordCommerce: 'MTIzMTIzMTI4MWE=',
  auth: {
    hmac: 'MTIzNDU2Nzg5MDowOTg3NjU0MzIx',
  },
};
